import { Pipe, PipeTransform } from '@angular/core';
import { CurrentProjektService } from 'src/app/projekter/services/current-projekt/current-projekt.service';
import { Rettighed } from '../models/rettighed';

/** This pipe can be used as <input [attr.disabled] = "'Ansoeg' | disableIfRettighedNotAchieved"></input>
 * if currentUser doesnt have the Rettighed listed, null is returned, otherwise 'true' is returned
 */
@Pipe({ name: 'disableIfRettighedNotAchieved' })
export class DisableOnRettighedPipe implements PipeTransform {
  constructor(private currentProjektService: CurrentProjektService) {}

  transform(rettighed: 'ProjektEjer' | 'Ansoeg' | 'Dokumentation' | 'Laes') {
    const requiredRettighed = Rettighed[rettighed];
    return this.hasPermission(requiredRettighed) ? null : 'true';
  }

  private hasPermission(requiredRettighed: Rettighed): boolean {
    return this.currentProjektService.hasPermission(requiredRettighed);
  }
}
